import { CancelFunctions } from 'components/common/types';
import { HEADERS_CONTENT_TYPE, HTTP_METHODS, URLS } from 'modules/api/constants';
import { OOCReport } from 'components/common/types/DirectSalesCampaign.types';
import handleRequest from './common';

export const getCampaignsWithOOCFrames = async (
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<OOCReport> => {
  const reqOptions = {
    url: URLS().DIRECT_SALES_CAMPAIGNS_WITH_OOC_FRAMES(marketId),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, 'DIRECT_SALES_CAMPAIGNS_WITH_OOC_FRAMES');
};
